export default "__VITE_ASSET__5UEUl9Sb__"